/**
 * Register block list properties.
 */
import { edit } from './edit';
import { save } from './save';
import metadata from './block.json';

export const settings = {
    ...metadata,
    edit,
    save,
}
